<div class="ti-language-and-statistics">
  <app-language-selection></app-language-selection>
  <app-statistics></app-statistics>
</div>
